import template from './tableGridModalLinkCell.html';
import controller from './tableGridModalLinkCell.controller';
import _ from 'lodash';

let tableGridModalLinkCellComponent = ($compile, modalLoaderService) => {
  return {
    restrict: 'E',
    template,
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      columns: '='
    },
    controller,
    controllerAs: 'vm',
    link: (scope, elem, attrs, ctrl) => {
      setScopeDefaults(scope, ctrl, modalLoaderService);
      let modalOptions = scope.vm.column.modalOptions;

      if (modalOptions) {
        setModalOptions(scope, modalOptions);
        fetchOrSetData(scope, ctrl, modalOptions);
      }
    }
  };
};

function fetchOrSetData(scope, ctrl, modalOptions) {
  ctrl.fetchOrSetData(scope, modalOptions)
    .then((success) => {
      scope.vm.data = success.data;
    },(error) => {
      scope.vm.isRequestFailure = true;
      console.log(error);
    });
}

function setScopeDefaults(scope, ctrl, modalLoaderService) {
  scope.vm = scope;
  scope.vm.column = _.find(scope.columns, {
    name: scope.columnName
  });
  scope.vm.modalLoaderService = modalLoaderService;
  scope.vm.getModalLinkText = ctrl.getModalLinkText;
  scope.vm.showModal = ctrl.showModal;
}

function setModalOptions(scope,modalOptions){
  scope.vm.modalComponent = modalOptions.contentComponent;
  scope.vm.modalContentClass = modalOptions.contentClass;
  scope.vm.modalLinkText = modalOptions.linkText;
}

tableGridModalLinkCellComponent.$inject = ['$compile', 'modalLoaderService'];

export default tableGridModalLinkCellComponent;


// WEBPACK FOOTER //
// ./app/components/tableGridModalLinkCell/tableGridModalLinkCell.component.js